import { ga, amplitude } from 'js/analytics/adapters'
import { baseWebEventProps, webpageProps } from 'js/analytics/standardizedProps'

export const trackViewLandingPage = () => {
  ga.track('view_landing_page')
  amplitude.track('user_view_page', {
    ...baseWebEventProps(),
    ...webpageProps(),
    action_name: 'view',
    action_type: 'active',
    page_view_type: 'landing_page_view',
  })
}
